<template>
	<div class="login-page-container">
		<div
			style="
				position: fixed;
				top: 20px;
				z-index: 49;
				backdrop-filter: blur(2px);
				display: flex;
				justify-content: center;
			"
			v-if="LoaderStatus"
		>
			<Spinner />
		</div>
		<div
			class="mobileLoginPage-container d-flex align-items-center justify-content-center"
		></div>
		<div class="d-flex flex-column w-100 dynamic-parent">
			<!-- Header with Mycareer title -->
			<div class="login-header">
				<h1 class="app-title">Hire3x</h1>
			</div>

			<!-- Main Login Card -->
			<div class="login-card">
				<!-- Welcome Section -->
				<div class="welcome-section">
					<h2 class="welcome-title">Reset Password</h2>
					<p class="welcome-text">
						Please enter the new credentials to reset your password
					</p>
				</div>

				<!-- New Password Input -->
				<div class="input-group" style="margin-top: 33px">
					<div class="input-wrapper">
						<label
							class="input-label"
							for="new-password"
							:class="{ active: password || isPasswordFocused }"
							>New Password</label
						>
						<b-form-input
							class="form-input"
							id="new-password"
							:type="showPassword ? 'text' : 'password'"
							v-model.trim="$v.password.$model"
							:class="{ error: $v.password.$error || checkpassowrdInvalid }"
							@focus="isPasswordFocused = true"
							@blur="isPasswordFocused = false"
							@input="validatePassword"
							@keypress.enter="resetPassword"
						></b-form-input>
						<div class="password-toggle pointer" @click="toggleShow">
							<img
								v-if="showPassword"
								src="@/assets/login/viewicon.svg"
								alt="Hide password"
							/>
							<img
								v-else
								src="@/assets/login/hideicon.svg"
								alt="Show password"
							/>
						</div>
					</div>
					<div
						class="validation-message"
						v-if="$v.password.$dirty && !$v.password.required"
					>
						Required
					</div>
					<div class="validation-message" v-else-if="checkpassowrdInvalid">
						{{ passwordminlength }}{{ passwordupper }}{{ passwordlower
						}}{{ passwordspecial }}{{ passwordnumber }}
					</div>
					<div
						class="validation-message"
						v-else-if="!$v.password.maxLength && $v.password.required"
					>
						Should not exceed 55 characters
					</div>
				</div>

				<!-- Confirm Password Input -->
				<div class="input-group mt-4">
					<div class="input-wrapper">
						<label
							class="input-label"
							for="confirm-password"
							:class="{ active: confirmpassword || isConfirmFocused }"
							>Confirm Password</label
						>
						<b-form-input
							class="form-input"
							id="confirm-password"
							type="password"
							v-model.trim="$v.confirmpassword.$model"
							:class="{ error: $v.confirmpassword.$error || match }"
							@focus="isConfirmFocused = true"
							@blur="isConfirmFocused = false"
							@keypress.enter="resetPassword"
						></b-form-input>
					</div>
					<div
						class="validation-message"
						v-if="$v.confirmpassword.$dirty && !$v.confirmpassword.required"
					>
						Required
					</div>
					<div
						class="validation-message"
						v-else-if="
							!$v.confirmpassword.maxLength && !$v.confirmpassword.required
						"
					>
						Should not exceed 55 characters
					</div>
					<div class="validation-message" v-else-if="match">
						Password mismatch
					</div>
					<div
						class="success-msg"
						v-else-if="
							$v.confirmpassword.$dirty &&
							$v.password.$dirty &&
							!match &&
							isConfirmFocused
						"
						style="
							color: #09ce76;
							font-size: 14px;
							margin-bottom: 15px;
							min-height: 20px;
						"
					>
						Password matched
					</div>
					<!-- General Error Message -->
					<div id="alertmessage" class="validation-message error-message">
						{{ invalidText }}
					</div>
				</div>

				<!-- Reset Button -->
				<button @click="resetPassword" class="login-button mt-4">
					RESET PASSWORD
				</button>

				<!-- Back to Login -->
				<div class="forgot-password-wrapper d-flex justify-content-center mt-4">
					<div @click="gotologin" class="forgot-password-link pointer">
						<span class="arrow-icon" style="margin-right: 5px">←</span> Back to
						Login
					</div>
				</div>

				<!-- Footer in Card (optional, or outside) -->
			</div>
			<div class="login-footer">
				Copyrights © 2026 Hire3x - All rights reserved.
			</div>
			<popupcomponent
				v-if="candexist || registered"
				:showPopup="candexist"
				:registered="registered"
				:invalidText="invalidText"
				:candExists="userExists"
				:successText="'Password reset success'"
			/>
		</div>
	</div>
</template>

<script>
import { required, maxLength } from "vuelidate/lib/validators";
import { resetPassword } from "../../utils/apiFunctions.js";
import Popupcomponent from "../../views/login/Popup.vue";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import { mapGetters } from "vuex";

export default {
	name: "ResetPassword",
	components: {
		Popupcomponent,
		Spinner,
	},
	data() {
		return {
			password: "",
			confirmpassword: "",
			showPassword: false,
			match: false,
			LoaderStatus: false,
			isPasswordFocused: false,
			isConfirmFocused: false,

			// Validation messages
			passwordminlength: "",
			passwordnumber: "",
			passwordspecial: "",
			passwordupper: "",
			passwordlower: "",

			// Status
			registered: false,
			candexist: false,
			invalidText: "",
			userExists: false,
			validPassword: false,
		};
	},
	computed: {
		...mapGetters({
			userData: "userVUEX/getUserData",
		}),
		checkpassowrdInvalid() {
			return (
				this.passwordminlength ||
				this.passwordupper ||
				this.passwordlower ||
				this.passwordspecial ||
				this.passwordnumber
			);
		},
	},
	validations: {
		password: {
			required,
			maxLength: maxLength(55),
		},
		confirmpassword: {
			required,
			maxLength: maxLength(55),
		},
	},
	watch: {
		password(value) {
			if (this.confirmpassword) {
				if (value == this.confirmpassword) {
					this.match = false;
				} else {
					this.match = true;
				}
			}
		},
		confirmpassword(value) {
			if (value == this.password) {
				this.match = false;
			} else {
				this.match = true;
			}
		},
	},
	methods: {
		toggleShow() {
			this.showPassword = !this.showPassword;
		},
		gotologin() {
			this.$router.push("/login");
		},
		clearData() {
			this.password = "";
			this.confirmpassword = "";
			this.$v.$reset();
		},
		validatePassword() {
			// Basic manual implementation of complex password validation
			// This mimics what was likely in LoginMixin
			const value = this.password;
			this.passwordminlength = value.length < 6 ? "Min 6 chars " : "";
			this.passwordnumber = !/\d/.test(value) ? "1 Number " : "";
			this.passwordspecial = !/[!@#$%^&*(),.?":{}|<>]/.test(value)
				? "1 Special char "
				: "";
			this.passwordupper = !/[A-Z]/.test(value) ? "1 Uppercase " : "";
			this.passwordlower = !/[a-z]/.test(value) ? "1 Lowercase " : "";

			if (
				!this.passwordminlength &&
				!this.passwordnumber &&
				!this.passwordspecial &&
				!this.passwordupper &&
				!this.passwordlower
			) {
				this.validPassword = false; // "false" means no error in this context logic often used
			} else {
				this.validPassword = true; // "true" means error exists
			}
		},
		async resetPassword() {
			this.$v.$touch();
			this.validatePassword(); // check complexity

			if (this.$v.$invalid || this.match || this.checkpassowrdInvalid) {
				return;
			}

			this.LoaderStatus = true;
			try {
				let payload = {
					email: this.userData.email,
					otp: this.userData.otp,
					password: this.password, // No trim if spaces allowed, but trim usually safe
				};
				const res = await resetPassword(payload);
				if (res.status == 200) {
					this.$store.commit("userVUEX/setUserData", {});
					this.LoaderStatus = false;
					this.registered = true;
					setTimeout(() => {
						this.registered = false;
						this.clearData();
						this.gotologin();
					}, 3000);
				} else {
					this.LoaderStatus = false;
					this.candexist = true;
					this.invalidText = "Password reset failed";
					setTimeout(() => {
						this.candexist = false;
						this.invalidText = "";
						this.clearData();
					}, 3000);
				}
			} catch (error) {
				this.LoaderStatus = false;
				this.invalidText =
					error.response?.data?.data?.Detail || "Something went wrong";
				this.candexist = true;
				setTimeout(() => {
					this.candexist = false;
					this.invalidText = "";
					this.clearData();
				}, 3000);
			}
		},
	},
};
</script>

<style scoped>
/* Reuse styles from LoginPage logic */
.login-page-container {
	height: 100dvh;
	background: #f4f4f4;
	padding: 10px;
	position: relative;
	display: flex;
	justify-content: center;
}
/* Header Section */
.login-header {
	width: 100%;
	text-align: center;
	margin-top: 13%;
	position: relative;
	z-index: 1;
}

.app-title {
	color: #ffffff;
	font-size: 25px;
	font-weight: 500;
	margin: 0;
	font-family: "Poppins", sans-serif;
}

/* Login Card */
.login-card {
	margin-top: 24px;
	z-index: 5;
	width: 98%;
	padding: 15px;
	border-radius: 12px;
	background: var(--White, #fff);
	box-shadow: 0 8px 50px -2px rgba(16, 24, 40, 0.08);
	height: -moz-fit-content;
	height: fit-content;
	max-height: fit-content;
}

/* Welcome Section */

.welcome-title {
	font-size: 30px;
	font-weight: 600;
	font-family: "lato", sans-serif;
	color: #464646;
	text-align: center;
}

.welcome-text {
	font-size: 15px;
	font-weight: 500;
	color: #3a3c40;
	font-family: "montserrat", sans-serif;
	text-align: center;
	margin: 0;
}

/* Error Message */
.validation-message {
	color: #dc3545;
	font-size: 14px;
	margin-top: 5px;
	min-height: 20px;
}

/* Input Groups */
.input-group {
	position: relative;
	display: block; /* Override bootstrap input-group if conflict */
}

.input-wrapper {
	position: relative;
	width: 100%;
}

.input-label {
	position: absolute;
	left: 12px;
	top: 50%;
	transform: translateY(-50%);
	pointer-events: none;
	transition: all 0.2s ease;
	background: #ffffff;
	padding: 0 4px;
	z-index: 1;
	opacity: 0.5;
}

.input-label.active {
	opacity: 1;
	top: 0;
	transform: translateY(-50%);
	font-size: 16px;
	color: #667085;
	background: #ffffff;
}

.form-input {
	color: #333;
	font-family: Inter, sans-serif;
	font-size: 16px;
	font-weight: 400;
	line-height: 19.36px;
	height: 45px;
	padding: 14px 20px;
	border-radius: 8px;
	border: 1px solid var(--gray-300, #d0d5dd);
	background: var(--White, #fff);
	opacity: 1;
	width: 100%;
}

.form-input:focus {
	border-color: #80bdff;
	outline: 0;
	box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.form-input.error {
	border-color: #dc3545;
}

.password-toggle {
	position: absolute;
	right: 15px;
	top: 50%;
	transform: translateY(-50%);
	cursor: pointer;
}

.login-button {
	width: 100%;
	padding: 12px;
	background-color: #20639b; /* Match the blue from image/login */
	color: white;
	border: none;
	border-radius: 8px;
	font-size: 16px;
	font-weight: 600;
	cursor: pointer;
	transition: background-color 0.2s;
	text-transform: uppercase;
}

.login-button:hover {
	background-color: #1a4f7a;
}

.arrow-icon {
	margin-left: 8px;
}

.forgot-password-link {
	color: #20639b;
	text-decoration: none;
	font-size: 14px;
	font-weight: 500;
}

.login-footer {
	text-align: center;
	color: #888;
	font-size: 12px;
	margin-top: 20px;
}

.pointer {
	cursor: pointer;
}
.mobileLoginPage-container {
	position: absolute;
	top: 0;
	z-index: 5;
	height: 50%;
	width: 100%;
	background: linear-gradient(158.58deg, #20639b -1.63%, #09b7c2 105.98%);
}
.dynamic-parent {
	overflow: hidden auto;
	background: transparent;
	z-index: 22;
	margin-right: -10px;
	padding-bottom: env(safe-area-inset-bottom);
	padding-top: env(safe-area-inset-top);
}
</style>
